// @flow

import React from "react";
import cx from "classnames";

import type { InputType } from "../Input/TextInput";

import styles from "./TextArea.scss";

type TextareaProps = {
  input: InputType,
  label: string,
  placeholder: string,
  rows: number,
  isDisabled: boolean,
  maxLength?: number,
  className?: string
};

const Textarea = ({
  label,
  placeholder,
  input,
  rows,
  isDisabled,
  maxLength,
  className
}: TextareaProps) => (
  <textarea
    {...input}
    aria-label={label}
    className={cx({ [styles.disabled]: isDisabled }, styles.textarea, className)}
    data-testid={`textArea:${input.name}`}
    data-name={input.name}
    placeholder={placeholder}
    rows={rows}
    disabled={isDisabled}
    maxLength={maxLength}
  />
);

Textarea.defaultProps = {
  input: null,
  label: "",
  placeholder: "",
  rows: 3,
  isDisabled: false
};

export default Textarea;
